import React from 'react';
import { Button, Modal, Space, TableProps } from 'antd';
import TableComponent from '../table';
import { IUser } from '@/interfaces/user';

interface IProps {
  data: IUser[];
  open: boolean;
  handleCancel: () => void;
}

const UserTableModal = ({ open, handleCancel, data }: IProps) => {
  const columns: TableProps<IUser>['columns'] = [
    {
      title: '#',
      dataIndex: 'id',
      key: 'id',
      width: 40,
      align: 'center',
      className: 'text-center',
      render: (_, rec, i) => <Space>{i + 1}</Space>,
    },
    {
      title: 'ชื่อ',
      dataIndex: 'firstName',
      key: 'firstName',
      className: 'font-bold',
      width: 140,
    },
    {
      title: 'นามสกุล',
      dataIndex: 'lastName',
      key: 'lastName',
      className: 'font-bold',
      width: 140,
    },
    {
      title: 'ชื่อเล่น',
      dataIndex: 'nickName',
      key: 'nickName',
      fixed: 'left',
      className: 'font-medium',
      width: 80,
    },
    {
      title: 'เบอร์โทร',
      dataIndex: 'phoneNumber',
      key: 'phoneNumber',
      className: 'font-medium',
    },
    {
      title: 'อีเมล์',
      dataIndex: 'email',
      key: 'email',
      className: 'font-medium',
    },
    {
      title: 'BU',
      dataIndex: 'bu',
      key: 'bu',
      className: 'font-medium',
    },
  ];

  return (
    <Modal
      title="ผู้ใช้งาน"
      open={open}
      width={'1200px'}
      onCancel={handleCancel}
      footer={[
        <Button key="back" onClick={handleCancel}>
          ปิด
        </Button>,
      ]}
    >
      <div className="flex w-full">
        <TableComponent<IUser>
          columns={columns}
          criteria={{}}
          data={{ data: data || [], totalRecords: data?.length }}
          loading={false}
          onTableChange={() => console.log()}
          showPagination={false}
          scroll={false}
        />
      </div>
    </Modal>
  );
};

export default UserTableModal;
